var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    { attrs: { show: _vm.loading } },
    [
      _vm.inPreview
        ? _c("pdf-preview", {
            attrs: {
              inPreview: _vm.inPreview,
              generatingPreview: _vm.generatingPreview,
              saving: _vm.saving,
              pdfUrl: _vm.pdfUrl,
              backToForm: _vm.backToForm,
              save: _vm.save
            }
          })
        : _c(
            "div",
            [
              _c(
                "form",
                {
                  attrs: { autocomplete: "off" },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "row" },
                    [
                      _c("div", { staticClass: "col-12" }, [
                        _c("h2", [
                          _vm._v(
                            "FORMULARIO CONVENIO DE PRESTACIÓN DE SERVICIOS A HONORARIOS"
                          )
                        ])
                      ]),
                      _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c(
                            "b-form-group",
                            [
                              _c(
                                "label",
                                { attrs: { for: "previousDocument" } },
                                [_vm._v(" ¿Deseas basarte en otro documento? ")]
                              ),
                              _c(
                                "v-select",
                                {
                                  attrs: {
                                    options: _vm.createdDocuments,
                                    name: "previousDocument",
                                    label: "label",
                                    "data-cy": "created-document-data",
                                    clearable: true
                                  },
                                  on: {
                                    input: function($event) {
                                      return _vm.getDocumentData($event)
                                    }
                                  },
                                  model: {
                                    value: _vm.previousDocument,
                                    callback: function($$v) {
                                      _vm.previousDocument = $$v
                                    },
                                    expression: "previousDocument"
                                  }
                                },
                                [
                                  _c("template", { slot: "no-options" }, [
                                    _vm._v(" no hay documentos registrados ")
                                  ])
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      !_vm.attachments || !_vm.attachments.length
                        ? _c(
                            "div",
                            { staticClass: "col-12 mb-4" },
                            [
                              _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "has-permission",
                                      rawName: "v-has-permission",
                                      value: "ED060",
                                      expression: "'ED060'"
                                    },
                                    {
                                      name: "b-modal",
                                      rawName: "v-b-modal",
                                      value: "add-repository-file",
                                      expression: "'add-repository-file'"
                                    }
                                  ],
                                  staticClass: "btn-icon mt-1 w-100",
                                  attrs: {
                                    variant: "secondary",
                                    "data-cy": "from-repository",
                                    disabled: _vm.attachments.length >= 1
                                  }
                                },
                                [
                                  _c("feather-icon", {
                                    attrs: { icon: "ServerIcon" }
                                  }),
                                  _vm._v(
                                    " Seleccionar SCH desde el repositorio "
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._l(_vm.attachments, function(file) {
                        return _c(
                          "div",
                          { key: file.id, staticClass: "col-12" },
                          [
                            _c(
                              "div",
                              { staticClass: "row align-items-center" },
                              [
                                _c("vs-icon", {
                                  staticClass: "col-2",
                                  attrs: {
                                    icon: "description",
                                    size: "25px",
                                    color: "primary"
                                  }
                                }),
                                _c(
                                  "b",
                                  { staticClass: "w-100 text-center col-8" },
                                  [_vm._v(_vm._s(file.name))]
                                ),
                                _c("vs-button", {
                                  staticClass: "col-2",
                                  attrs: {
                                    color: "danger",
                                    type: "flat",
                                    icon: "clear"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.removeRepositoryFile(file.id)
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      }),
                      !_vm.attachments || !_vm.attachments.length
                        ? _c("div", { staticClass: "col-12" }, [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "danger span-text-validation-danger v-enter-to"
                              },
                              [
                                _c("small", [
                                  _vm._v(
                                    " Debes seleccionar un archivo desde el repositorio "
                                  )
                                ])
                              ]
                            )
                          ])
                        : _vm._e()
                    ],
                    2
                  ),
                  _vm.attachments && _vm.attachments.length && !_vm.loading
                    ? _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-12" },
                          [_c("vs-divider")],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-6" },
                          [
                            _c(
                              "b-form-group",
                              [
                                _c(
                                  "label",
                                  { attrs: { for: "agreementDate" } },
                                  [
                                    _vm._v(" Fecha convenio "),
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.required("agreementDate")
                                        )
                                      }
                                    })
                                  ]
                                ),
                                _c("date-picker", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    }
                                  ],
                                  class: {
                                    "w-100": true,
                                    danger: _vm.$validator.errors.has(
                                      "agreementDate"
                                    )
                                  },
                                  attrs: {
                                    "data-cy": "agreementDate",
                                    name: "agreementDate",
                                    "data-vv-as": "fecha convenio",
                                    format: "DD/MM/YYYY",
                                    "value-type": "DD/MM/YYYY",
                                    placeholder: "Ej: 30/12/2000",
                                    danger: _vm.$validator.errors.has(
                                      "agreementDate"
                                    )
                                  },
                                  model: {
                                    value: _vm.formData.agreementDate,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "agreementDate",
                                        $$v
                                      )
                                    },
                                    expression: "formData.agreementDate"
                                  }
                                }),
                                _vm.$validator.errors.has("agreementDate")
                                  ? _c("v-invalid-feedback", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$validator.errors.first(
                                              "agreementDate"
                                            )
                                          ) +
                                          " "
                                      )
                                    ])
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-6 mt-3" },
                          [
                            _c(
                              "b-form-group",
                              {},
                              [
                                _c(
                                  "b-form-checkbox",
                                  {
                                    staticClass: "m-0",
                                    attrs: {
                                      name: "regularizesAgreement",
                                      "data-cy": "regularizes-agreement",
                                      "data-vv-as":
                                        "¿Esta solicitud regulariza convenio?"
                                    },
                                    model: {
                                      value: _vm.formData.regularizesAgreement,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "regularizesAgreement",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formData.regularizesAgreement"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " ¿Esta solicitud regulariza convenio? "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm.formData.nationality !== "Chilena"
                          ? _c(
                              "div",
                              { staticClass: "col-6" },
                              [
                                _c(
                                  "b-form-group",
                                  [
                                    _c(
                                      "vs-checkbox",
                                      {
                                        staticClass: "mb-3",
                                        attrs: { color: "primary" },
                                        model: {
                                          value: _vm.formData.hasResidence,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "hasResidence",
                                              $$v
                                            )
                                          },
                                          expression: "formData.hasResidence"
                                        }
                                      },
                                      [_vm._v(" Tiene residencia definitiva ")]
                                    ),
                                    _vm.$validator.errors.has("hasResidence")
                                      ? _c("v-invalid-feedback", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$validator.errors.first(
                                                  "hasResidence"
                                                )
                                              ) +
                                              " "
                                          )
                                        ])
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          { staticClass: "col-12" },
                          [
                            _c(
                              "b-form-group",
                              [
                                _c(
                                  "label",
                                  { attrs: { for: "functionDate" } },
                                  [
                                    _vm._v(" Asumirá funciones desde "),
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.required("functionDate")
                                        )
                                      }
                                    })
                                  ]
                                ),
                                _c("date-picker", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    }
                                  ],
                                  class: {
                                    "w-100": true,
                                    danger: _vm.$validator.errors.has(
                                      "functionDate"
                                    )
                                  },
                                  attrs: {
                                    "data-cy": "functionDate",
                                    name: "functionDate",
                                    "data-vv-as": "asumirá funciones desde",
                                    format: "DD/MM/YYYY",
                                    "value-type": "DD/MM/YYYY",
                                    placeholder: "Ej: 30/12/2000",
                                    danger: _vm.$validator.errors.has(
                                      "functionDate"
                                    )
                                  },
                                  model: {
                                    value: _vm.formData.functionDate,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "functionDate",
                                        $$v
                                      )
                                    },
                                    expression: "formData.functionDate"
                                  }
                                }),
                                _vm.$validator.errors.has("functionDate")
                                  ? _c("v-invalid-feedback", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$validator.errors.first(
                                              "functionDate"
                                            )
                                          ) +
                                          " "
                                      )
                                    ])
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-12" },
                          [
                            _c(
                              "b-form-group",
                              [
                                _c("label", { attrs: { for: "first" } }, [
                                  _vm._v(" Primero: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(_vm.required("first"))
                                    }
                                  })
                                ]),
                                _c("editor-text", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    }
                                  ],
                                  ref: "third",
                                  attrs: {
                                    "data-cy": "first",
                                    name: "first",
                                    "data-vv-as": "primero",
                                    placeholder: "PRIMERO: ...",
                                    "max-length": 5000,
                                    "with-counter": ""
                                  },
                                  model: {
                                    value: _vm.formData.first,
                                    callback: function($$v) {
                                      _vm.$set(_vm.formData, "first", $$v)
                                    },
                                    expression: "formData.first"
                                  }
                                }),
                                _vm.$validator.errors.has("first")
                                  ? _c("v-invalid-feedback", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$validator.errors.first("first")
                                          ) +
                                          " "
                                      )
                                    ])
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm.formData.functionDate
                          ? _c("div", [
                              _vm.formData.isDocenteForm
                                ? _c(
                                    "div",
                                    { staticClass: "col-12" },
                                    [
                                      _c(
                                        "b-form-group",
                                        [
                                          _c(
                                            "label",
                                            { attrs: { for: "third" } },
                                            [
                                              _vm._v(" Tercero: "),
                                              _c("span", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.required("third")
                                                  )
                                                }
                                              })
                                            ]
                                          ),
                                          _c("editor-text", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            ref: "third",
                                            attrs: {
                                              "data-cy": "third",
                                              name: "third",
                                              "data-vv-as": "tercero",
                                              placeholder: "TERCERO: ...",
                                              "max-length": 5000,
                                              "with-counter": ""
                                            },
                                            model: {
                                              value: _vm.formData.third,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "third",
                                                  $$v
                                                )
                                              },
                                              expression: "formData.third"
                                            }
                                          }),
                                          _vm.$validator.errors.has("third")
                                            ? _c("v-invalid-feedback", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$validator.errors.first(
                                                        "third"
                                                      )
                                                    ) +
                                                    " "
                                                )
                                              ])
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.formData.isNotDocenteForm
                                ? _c(
                                    "div",
                                    { staticClass: "col-12 mb-4" },
                                    [
                                      _c(
                                        "vs-table",
                                        {
                                          staticClass: "wrap-table border",
                                          attrs: {
                                            hoverFlat: "",
                                            data:
                                              _vm.formData
                                                .assocProductsAndServices || [],
                                            noDataText:
                                              "Aún no se han agregado productos y servicios asociados"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(ref) {
                                                  var data = ref.data
                                                  return [
                                                    _c(
                                                      "tbody",
                                                      _vm._l(data, function(
                                                        _,
                                                        idx
                                                      ) {
                                                        return _c(
                                                          "vs-tr",
                                                          { key: idx },
                                                          [
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "p-1",
                                                                staticStyle: {
                                                                  width: "20%"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "b-form-textarea",
                                                                  {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "validate",
                                                                        rawName:
                                                                          "v-validate",
                                                                        value:
                                                                          "required",
                                                                        expression:
                                                                          "'required'"
                                                                      }
                                                                    ],
                                                                    attrs: {
                                                                      rows:
                                                                        data[
                                                                          idx
                                                                        ].month
                                                                          .toString()
                                                                          .split(
                                                                            "\n"
                                                                          )
                                                                          .length +
                                                                        1,
                                                                      name:
                                                                        "assocProductsAndServices[" +
                                                                        idx +
                                                                        "].month",
                                                                      "data-cy":
                                                                        "assocProductsAndServices[" +
                                                                        idx +
                                                                        "].month",
                                                                      "data-vv-as":
                                                                        "mes",
                                                                      placeholder:
                                                                        "Mes...",
                                                                      state: _vm.$validator.errors.has(
                                                                        "assocProductsAndServices[" +
                                                                          idx +
                                                                          "].month"
                                                                      )
                                                                        ? false
                                                                        : null,
                                                                      danger: _vm.$validator.errors.has(
                                                                        "assocProductsAndServices[" +
                                                                          idx +
                                                                          "].month"
                                                                      ),
                                                                      "danger-text": _vm.$validator.errors.first(
                                                                        "assocProductsAndServices[" +
                                                                          idx +
                                                                          "].month"
                                                                      )
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        data[
                                                                          idx
                                                                        ].month,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          data[
                                                                            idx
                                                                          ],
                                                                          "month",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "data[idx].month"
                                                                    }
                                                                  }
                                                                ),
                                                                _vm.$validator.errors.has(
                                                                  "assocProductsAndServices[" +
                                                                    idx +
                                                                    "].month"
                                                                )
                                                                  ? _c(
                                                                      "v-invalid-feedback",
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.$validator.errors.first(
                                                                                "assocProductsAndServices[" +
                                                                                  idx +
                                                                                  "].month"
                                                                              )
                                                                            ) +
                                                                            " "
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e()
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "p-1",
                                                                staticStyle: {
                                                                  width: "30%"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "b-form-textarea",
                                                                  {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "validate",
                                                                        rawName:
                                                                          "v-validate",
                                                                        value:
                                                                          "required",
                                                                        expression:
                                                                          "'required'"
                                                                      }
                                                                    ],
                                                                    attrs: {
                                                                      rows:
                                                                        data[
                                                                          idx
                                                                        ].product
                                                                          .toString()
                                                                          .split(
                                                                            "\n"
                                                                          )
                                                                          .length +
                                                                        1,
                                                                      name:
                                                                        "assocProductsAndServices[" +
                                                                        idx +
                                                                        "].product",
                                                                      "data-cy":
                                                                        "assocProductsAndServices[" +
                                                                        idx +
                                                                        "].product",
                                                                      "data-vv-as":
                                                                        "producto",
                                                                      placeholder:
                                                                        "Producto...",
                                                                      state: _vm.$validator.errors.has(
                                                                        "assocProductsAndServices[" +
                                                                          idx +
                                                                          "].product"
                                                                      )
                                                                        ? false
                                                                        : null,
                                                                      danger: _vm.$validator.errors.has(
                                                                        "assocProductsAndServices[" +
                                                                          idx +
                                                                          "].product"
                                                                      ),
                                                                      "danger-text": _vm.$validator.errors.first(
                                                                        "assocProductsAndServices[" +
                                                                          idx +
                                                                          "].product"
                                                                      )
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        data[
                                                                          idx
                                                                        ]
                                                                          .product,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          data[
                                                                            idx
                                                                          ],
                                                                          "product",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "data[idx].product"
                                                                    }
                                                                  }
                                                                ),
                                                                _vm.$validator.errors.has(
                                                                  "assocProductsAndServices[" +
                                                                    idx +
                                                                    "].product"
                                                                )
                                                                  ? _c(
                                                                      "b-form-invalid-feedback",
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.$validator.errors.first(
                                                                                "assocProductsAndServices[" +
                                                                                  idx +
                                                                                  "].product"
                                                                              )
                                                                            ) +
                                                                            " "
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e()
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "p-1",
                                                                staticStyle: {
                                                                  width: "20%"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "b-form-textarea",
                                                                  {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "validate",
                                                                        rawName:
                                                                          "v-validate",
                                                                        value:
                                                                          "required",
                                                                        expression:
                                                                          "'required'"
                                                                      }
                                                                    ],
                                                                    attrs: {
                                                                      rows:
                                                                        data[
                                                                          idx
                                                                        ].valuation
                                                                          .toString()
                                                                          .split(
                                                                            "\n"
                                                                          )
                                                                          .length +
                                                                        1,
                                                                      name:
                                                                        "assocProductsAndServices[" +
                                                                        idx +
                                                                        "].valuation",
                                                                      "data-cy":
                                                                        "assocProductsAndServices[" +
                                                                        idx +
                                                                        "].valuation",
                                                                      "data-vv-as":
                                                                        "Valoración",
                                                                      placeholder:
                                                                        "Valorización...",
                                                                      state: _vm.$validator.errors.has(
                                                                        "assocProductsAndServices[" +
                                                                          idx +
                                                                          "].valuation"
                                                                      )
                                                                        ? false
                                                                        : null,
                                                                      danger: _vm.$validator.errors.has(
                                                                        "assocProductsAndServices[" +
                                                                          idx +
                                                                          "].valuation"
                                                                      ),
                                                                      "danger-text": _vm.$validator.errors.first(
                                                                        "assocProductsAndServices[" +
                                                                          idx +
                                                                          "].valuation"
                                                                      )
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        data[
                                                                          idx
                                                                        ]
                                                                          .valuation,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          data[
                                                                            idx
                                                                          ],
                                                                          "valuation",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "data[idx].valuation"
                                                                    }
                                                                  }
                                                                ),
                                                                _vm.$validator.errors.has(
                                                                  "assocProductsAndServices[" +
                                                                    idx +
                                                                    "].valuation"
                                                                )
                                                                  ? _c(
                                                                      "b-form-invalid-feedback",
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.$validator.errors.first(
                                                                                "assocProductsAndServices[" +
                                                                                  idx +
                                                                                  "].valuation"
                                                                              )
                                                                            ) +
                                                                            " "
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e()
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "p-1",
                                                                staticStyle: {
                                                                  width: "30%"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "b-form-textarea",
                                                                  {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "validate",
                                                                        rawName:
                                                                          "v-validate",
                                                                        value:
                                                                          "required",
                                                                        expression:
                                                                          "'required'"
                                                                      }
                                                                    ],
                                                                    attrs: {
                                                                      rows:
                                                                        data[
                                                                          idx
                                                                        ].verificator
                                                                          .toString()
                                                                          .split(
                                                                            "\n"
                                                                          )
                                                                          .length +
                                                                        1,
                                                                      name:
                                                                        "assocProductsAndServices[" +
                                                                        idx +
                                                                        "].verificator",
                                                                      "data-cy":
                                                                        "assocProductsAndServices[" +
                                                                        idx +
                                                                        "].verificator",
                                                                      "data-vv-as":
                                                                        "verificador",
                                                                      placeholder:
                                                                        "Verificador...",
                                                                      state: _vm.$validator.errors.has(
                                                                        "assocProductsAndServices[" +
                                                                          idx +
                                                                          "].verificator"
                                                                      )
                                                                        ? false
                                                                        : null,
                                                                      danger: _vm.$validator.errors.has(
                                                                        "assocProductsAndServices[" +
                                                                          idx +
                                                                          "].verificator"
                                                                      ),
                                                                      "danger-text": _vm.$validator.errors.first(
                                                                        "assocProductsAndServices[" +
                                                                          idx +
                                                                          "].verificator"
                                                                      )
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        data[
                                                                          idx
                                                                        ]
                                                                          .verificator,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          data[
                                                                            idx
                                                                          ],
                                                                          "verificator",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "data[idx].verificator"
                                                                    }
                                                                  }
                                                                ),
                                                                _vm.$validator.errors.has(
                                                                  "assocProductsAndServices[" +
                                                                    idx +
                                                                    "].verificator"
                                                                )
                                                                  ? _c(
                                                                      "b-form-invalid-feedback",
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.$validator.errors.first(
                                                                                "assocProductsAndServices[" +
                                                                                  idx +
                                                                                  "].verificator"
                                                                              )
                                                                            ) +
                                                                            " "
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e()
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        )
                                                      }),
                                                      1
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            2547352213
                                          )
                                        },
                                        [
                                          _c("template", { slot: "header" }, [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "w-100 p-2 text-center font-bold"
                                              },
                                              [
                                                _vm._v(
                                                  " Servicios y productos asociados "
                                                )
                                              ]
                                            )
                                          ]),
                                          _c("template", { slot: "thead" }, [
                                            _c("th", [_vm._v(" Mes ")]),
                                            _c("th", [_vm._v(" Producto ")]),
                                            _c("th", [_vm._v(" Valoración ")]),
                                            _c("th", [_vm._v(" Verificador ")])
                                          ])
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "div",
                                { staticClass: "col-12" },
                                [
                                  _c(
                                    "b-form-group",
                                    [
                                      _c(
                                        "label",
                                        {
                                          attrs: {
                                            for: "installmentsBreakdown"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " Desglose del periodo de pago "
                                          ),
                                          _c("span", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.required(
                                                  "installmentsBreakdown"
                                                )
                                              )
                                            }
                                          })
                                        ]
                                      ),
                                      _c("editor-text", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required",
                                            expression: "'required'"
                                          }
                                        ],
                                        ref: "installmentsBreakdown",
                                        attrs: {
                                          "data-cy": "installmentsBreakdown",
                                          name: "installmentsBreakdown",
                                          "data-vv-as": "desglose de cuotas",
                                          placeholder: "Desglose de cuotas...",
                                          "max-length": 5000,
                                          "with-counter": ""
                                        },
                                        model: {
                                          value:
                                            _vm.formData.installmentsBreakdown,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "installmentsBreakdown",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.installmentsBreakdown"
                                        }
                                      }),
                                      _vm.$validator.errors.has(
                                        "installmentsBreakdown"
                                      )
                                        ? _c("v-invalid-feedback", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$validator.errors.first(
                                                    "installmentsBreakdown"
                                                  )
                                                ) +
                                                " "
                                            )
                                          ])
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "col-12" },
                                [
                                  _c(
                                    "b-form-group",
                                    [
                                      _c("label", { attrs: { for: "ninth" } }, [
                                        _vm._v(" Noveno: "),
                                        _c("span", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.required("ninth")
                                            )
                                          }
                                        })
                                      ]),
                                      _c("editor-text", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required",
                                            expression: "'required'"
                                          }
                                        ],
                                        ref: "ninth",
                                        attrs: {
                                          "data-cy": "ninth",
                                          name: "ninth",
                                          "data-vv-as": "noveno",
                                          placeholder: "NOVENO: ...",
                                          "max-length": 5000,
                                          "with-counter": ""
                                        },
                                        model: {
                                          value: _vm.formData.ninth,
                                          callback: function($$v) {
                                            _vm.$set(_vm.formData, "ninth", $$v)
                                          },
                                          expression: "formData.ninth"
                                        }
                                      }),
                                      _vm.$validator.errors.has("ninth")
                                        ? _c("v-invalid-feedback", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$validator.errors.first(
                                                    "ninth"
                                                  )
                                                ) +
                                                " "
                                            )
                                          ])
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "col-12" },
                                [
                                  _c(
                                    "b-form-group",
                                    [
                                      _c(
                                        "label",
                                        { attrs: { for: "agreementProvides" } },
                                        [
                                          _vm._v(" El convenio contempla: "),
                                          _c("span", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.required(
                                                  "agreementProvides"
                                                )
                                              )
                                            }
                                          })
                                        ]
                                      ),
                                      _c("editor-text", {
                                        ref: "agreementProvides",
                                        attrs: {
                                          "data-cy": "agreementProvides",
                                          name: "agreementProvides",
                                          "data-vv-as": "el convenio contempla",
                                          placeholder:
                                            "El convenio contempla...",
                                          danger: _vm.$validator.errors.has(
                                            "agreementProvides"
                                          ),
                                          "danger-text": _vm.$validator.errors.first(
                                            "agreementProvides"
                                          ),
                                          state: _vm.$validator.errors.has(
                                            "agreementProvides"
                                          )
                                            ? false
                                            : null,
                                          "max-length": 5000,
                                          "with-counter": ""
                                        },
                                        model: {
                                          value: _vm.formData.agreementProvides,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "agreementProvides",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.agreementProvides"
                                        }
                                      }),
                                      _vm.$validator.errors.has(
                                        "agreementProvides"
                                      )
                                        ? _c("v-invalid-feedback", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$validator.errors.first(
                                                    "agreementProvides"
                                                  )
                                                ) +
                                                " "
                                            )
                                          ])
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ])
                          : _vm._e(),
                        _c(
                          "div",
                          { staticClass: "col-12" },
                          [
                            _c(
                              "b-form-group",
                              [
                                _c("label", { attrs: { for: "first" } }, [
                                  _vm._v(" Quinto: "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(_vm.required("fifth"))
                                    }
                                  })
                                ]),
                                _c("editor-text", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    }
                                  ],
                                  ref: "third",
                                  attrs: {
                                    "data-cy": "fifth",
                                    name: "fifth",
                                    "data-vv-as": "quinto",
                                    placeholder: "QUINTO: ...",
                                    "max-length": 5000,
                                    "with-counter": ""
                                  },
                                  model: {
                                    value: _vm.formData.fifth,
                                    callback: function($$v) {
                                      _vm.$set(_vm.formData, "fifth", $$v)
                                    },
                                    expression: "formData.fifth"
                                  }
                                }),
                                _vm.$validator.errors.has("fifth")
                                  ? _c("v-invalid-feedback", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$validator.errors.first("fifth")
                                          ) +
                                          " "
                                      )
                                    ])
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    : _vm._e()
                ]
              ),
              _c("small", [
                _c("b", [
                  _vm._v("Los campos marcados con "),
                  _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
                  _vm._v(" son obligatorios")
                ])
              ]),
              _c("form-action-buttons", {
                attrs: {
                  saving: _vm.saving,
                  preview: _vm.preview,
                  back: _vm.back,
                  save: _vm.save,
                  saveDraft: _vm.saveDraft
                }
              })
            ],
            1
          ),
      _c("repository-selector", {
        attrs: {
          "add-file": _vm.addRepositoryFile,
          files: _vm.attachments,
          "remove-file": _vm.removeRepositoryFile,
          "max-files": 1,
          "required-file-type": "SCH",
          "required-approval-state": _vm.approvalStateTypes.APPROVED
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }